__turbopack_context__.v({
  "className": "satoshi_61911acf-module__8iv71q__className",
});
